import { SelectiveTargetingOption } from '../SelectiveTargeting.types';
import { SelectiveTargetingOptionValues } from './enums';

export const SELECTIVE_TARGETING_EMPTY_STATE_CONTENT = {
  inApp: {
    messagePartOne: 'To target specific apps and websites, ',
    messagePartTwo:
      '. Until then, in-app messages are available to all of your apps (through our API).',
  },
  push: {
    messagePartOne: 'To target specific apps, ',
    messagePartTwo:
      '. Until then, push messages are available to all of your apps (through our API).',
  },
  addToProject: 'add them to your project',
  learnMore: 'Learn more',
};

export const SELECTIVE_TARGETING_PLACEHOLDER_OPTIONS = [
  {
    id: 'placeholder-option',
    label: '',
    value: '',
  },
];

export const SELECTIVE_TARGETING_OPTIONS: SelectiveTargetingOption[] = [
  {
    id: 'selective-targeting-all-mobile-apps',
    value: SelectiveTargetingOptionValues.ALL_MOBILE_APPS,
    name: 'All mobile apps',
    tooltip: `Sends messages to all the mobile apps you've integrated with Iterable (even those you haven't added to the Settings > Apps and Websites page).`,
  },
  {
    id: 'selective-targeting-all-websites',
    value: SelectiveTargetingOptionValues.ALL_WEBSITES,
    name: 'All websites',
    tooltip: '',
  },
  {
    id: 'selective-targeting-everything',
    value: SelectiveTargetingOptionValues.EVERYTHING,
    name: 'Everything',
    tooltip: `Sends messages to all the mobile apps and websites you've integrated with Iterable (even those you haven't added to the Settings > Apps and Websites page).`,
  },
  {
    id: 'selective-targeting-ott',
    value: SelectiveTargetingOptionValues.OTT,
    name: 'OTT',
    tooltip: '',
  },
  {
    id: 'selective-targeting-custom',
    value: SelectiveTargetingOptionValues.CUSTOM,
    name: 'Custom',
    tooltip: '',
  },
];
